export const baseData = {
  title: "BANK"
}